<template>
  <div>
    <customCommon :customFlag="false" :btnFlg= 'btnFlg'></customCommon>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import customCommon from '@/views/newTMS/basicSettings/components/customCommon.vue'
export default{
  components: {
    customCommon
  },
  data() {
    return{
      btnFlg: [],
      btnIdArr: ['01N0090100', '01N0090200', '01N0090300', '01N0090400'],
    }
  },
  created(){
    this.btnFlg = getBtn(this.btnIdArr,'/carrierTMS')
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>

</style>
